import { render } from "./ExportPage.vue?vue&type=template&id=0532b10a&scoped=true"
import script from "./ExportPage.vue?vue&type=script&lang=js"
export * from "./ExportPage.vue?vue&type=script&lang=js"

import "./ExportPage.vue?vue&type=style&index=0&id=0532b10a&scoped=true&lang=css"

import exportComponent from "../../../../procollege/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0532b10a"]])

export default __exports__